__turbopack_context__.v({
  "arrow": "workItem-module-scss-module__FEhlTa__arrow",
  "container": "workItem-module-scss-module__FEhlTa__container",
  "container-selected": "workItem-module-scss-module__FEhlTa__container-selected",
  "icon": "workItem-module-scss-module__FEhlTa__icon",
  "id": "workItem-module-scss-module__FEhlTa__id",
  "item": "workItem-module-scss-module__FEhlTa__item",
});
